 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/game-rules/pages/content/intellectual-property/pages/content/l/9f3ea104","2":"pages/cashbox/history/pages/cashbox/payin-error/pages/cashbox/payin-status-ext/pages/cashbox/payin-s/61fd3eac","17":"pages/index/pages/lobby/_section/pages/lobby/_section/_sub-section","19":"pages/cashbox/deposit/pages/cashbox/withdrawal","20":"pages/profile/pages/profile/bonuses/index","32":"header-c","33":"lang-ru.js","34":"lang-ua.js","35":"pages/auth/_social/cb","36":"pages/cashbox/deposit","37":"pages/cashbox/history","38":"pages/cashbox/index","39":"pages/cashbox/payin-error","40":"pages/cashbox/payin-status-ext","41":"pages/cashbox/payin-success","42":"pages/cashbox/payout-error","43":"pages/cashbox/payout-success","44":"pages/cashbox/support","45":"pages/cashbox/withdrawal","46":"pages/content/amlpolicy","47":"pages/content/faq","48":"pages/content/game-rules","49":"pages/content/intellectual-property","50":"pages/content/license","51":"pages/content/partners","52":"pages/content/privacy-policy","53":"pages/content/responsible-gaming","54":"pages/content/rules","55":"pages/error-game","56":"pages/game/_term","57":"pages/index","58":"pages/lobby/_section","59":"pages/lobby/_section/_sub-section","60":"pages/profile","61":"pages/profile/bonuses/index","62":"pages/profile/kycaid","63":"pages/profile/settings/index","64":"pages/profile/support-faq/index","65":"pages/promotions/_term","66":"pages/promotions/index","67":"pages/promotions/welcome-pack/index","68":"pages/registration","69":"pages/verifications/index","72":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"b8d636cd5d21821089f2","1":"44f96de5ad6095e804e9","2":"d1f8a42d9f84d3151f53","3":"23669df5c98e2032a60d","4":"a1b7d9f26de6ee09ab63","5":"751c057cd179a01feeaf","6":"512848f7f0ef950f5144","7":"adf8b1af5a14990d073e","8":"442f154881f21503f30b","9":"07c662d85c14bcc28ef8","10":"0ecb1db130c5573ed559","11":"41af82a1c731550a8bc0","12":"1132ff2772d9814c5e6a","13":"ea681db64798c3736604","14":"d91f436b79aeaebf4d30","15":"1e99d366d2a43fad8c7a","16":"9faa11295cb79fa8bf82","17":"e9212d51fed0754967fc","18":"f24d45f69cf1e472e42a","19":"ef96e488f492f195b230","20":"bcdae90aa05c3a95ce1b","21":"b611368404ee8b80cb9d","22":"ff9c616078f127d959bd","23":"72957b190dc8433483b1","24":"4c9490d9735c1c9b5928","25":"0ea4be16464d72080049","26":"874a634e2f3964197788","27":"f682cf9812e887d12864","28":"9e53fbd41aa20ea60431","29":"43e1e674bb49fe542839","32":"6b8802276bdc5a047411","33":"0e07fad2266fac130cb0","34":"9a383e19b1d8720b5457","35":"63921e690a13815aa6c1","36":"8e1cacd4976c5a9b2e00","37":"09e68d1268e95556a762","38":"0c6047d47da05c4c61bb","39":"469e18bb6fa5de25e2c8","40":"96b7318a046091c744cd","41":"9fa89ac5dfa84be64f92","42":"8af8dd240e6696a443a7","43":"f46f9c2b513aacd1e2f4","44":"21a7c754fe4a06514d32","45":"ae6d0c5960df91440858","46":"f79aeae76733f766403b","47":"34cbe3b600bd5ece2d26","48":"0f1557fefd77522ea14c","49":"99f41dd636e05fd64c1d","50":"d8333d24cec15c523f69","51":"7dd4fbd5fde761b673e4","52":"2486fd7f46b7a5fc70cb","53":"d34f575b6eb7e16fc509","54":"68a5b25dd1d2631f3a38","55":"caf566a396002fb021a5","56":"9a8e0e15952132e72030","57":"95c047dfd76df88aeef8","58":"817f9e058ebe7c749cb2","59":"14690ba4921410e9ef15","60":"9920a2e6cde6bdde80da","61":"ba6bf46eae63ce5930a9","62":"8ce21d6c4335dba1f625","63":"3c9dd000692f7284c2be","64":"fa046e6842f645b8e440","65":"caf4d4987cbefa89a6ae","66":"fa5ac5e1a3bc512b80eb","67":"09ef3af10fa85776d6e0","68":"8a0f006bef29e3c5cced","69":"7a21a45b1d69989167ca","72":"afb2cffbfb164160eae0","73":"9ba4b2027f9f8aff4056","74":"2b932f039758d0845047","75":"cc9bc1c880b0586f7e53","76":"a03475444a729386934a","77":"8485dff095bd6f0ea797","78":"fcb696a95da22e60d1af","79":"1d06651bce74337b8289","80":"3b371f5d4f9ee9855b9d","81":"61ba3862c26b429aa18d","82":"1eee5552db2c64e044f5","83":"87d3a7e91801527f0893","84":"3c267d4ac33e0e11e286","85":"c74dea8921af3663ba4a","86":"b33b6d1703596df6a54c","87":"61b5ffe96b71fbfbd6f0","88":"a1cfd2f4bd7f0198dc79","89":"5dd62330b37d1c73d090","90":"18d27f47b1072558ddb4","91":"39e5625ad851b3327433","92":"b94eb32b87ed7ca8bd65","93":"c661f37607462f2a3eec","94":"88b5989119659a5230ad","95":"7992ab57de80fa566ecb","96":"5cd3149e9343b6442bb7","97":"88800ef96aa193cd458a","98":"ab9a1b3ff614ad5e778a","99":"12d82f2ef51398536b45","100":"ac059761de932e0b7dc3","101":"5639ffefc85f8a65a43c","102":"4e42432e6c9737df73fb","103":"bfac2806f5b34462f322","104":"cce62a9c53f176447e79","105":"372b178c2ec09508fa12","106":"0f79da6cd7fce10dff4d","107":"51a963db9bd1530b4f99","108":"ab413ca1bc45db2d145d","109":"67b7463b70739eb6c32e","110":"1e6d07b4cde9e36a9b6f","111":"b1e25ec61ccada068d3c","112":"9859ffe1efaa4b959e71","113":"641d1364fe8e1e6e477b","114":"ce17e0d25c2378af52a8","115":"a6380cf9e27d3da801df","116":"14cd137c75f385669e0c","117":"d190f831d5437a5ea69f","118":"74c1b457e7b64ee30b49","119":"09d9e7c914c23cbd0c8f","120":"5beae1cf785112ab38b6","121":"baac1a7ae6f966027934","122":"923662819853b10c1011","123":"ee6f4e4f52a04ecd9c44","124":"4c2e4f584dcf66c44d6a","125":"3a0d0f75c39cd492029a","126":"e9e12a7c4f741c1aa2e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
